// @TODO Возможно нужно будет доработать метод для других типов форматов

/**
 * Форматированный вывод телефонного номера
 * @param phone string (example: 79995553322 or +79995553322)
 * @returns string
 */
export const getFormattedPhoneNumber = (phone: string): string => {
    let preparedString = phone;

    if (typeof phone.charAt(0) !== 'number') {
        preparedString = Number(phone).toString();
    }

    return preparedString.replace(/([\d]{1})([\d]{3})([\d]{3})([\d]{2})([\d]{2})/g, '+$1 $2 $3 $4 $5');
};
